import { render, staticRenderFns } from "./ReviewFromRbIcon.vue?vue&type=template&id=d2a78fb0&"
import script from "./ReviewFromRbIcon.vue?vue&type=script&lang=js&"
export * from "./ReviewFromRbIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports